<template>
  <div class="select-control" style="width: 100%">
    <stb-multi-select
      :id="objId"
      :select-options="riskCategories"
      :disabled="!formControlEnabled"
      :placeholder="placeholder"
      :get-disabled-state="getDisabledState"
      @stb-multi-select-change="onMultiSelectChange"
    />

    <risk-class
      :selectedrisk-classes="selectedRiskClasses"
      :form-control-enabled="formControlEnabled"
      :risk-type-label-displayed="true"
      @changeRiskCategoryDone="changeRiskCategory"
    ></risk-class>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { find, get } from 'lodash';
import RiskClass from './RiskClass';
import StbMultiSelect from './StbMultiSelect';

export default {
  name: 'SelectControl',

  components: {
    RiskClass,
    StbMultiSelect
  },

  props: ['name', 'id', 'formControlEnabled'],

  emits: ['changeRiskCategoryDone'],

  data() {
    return {
      riskCategoryMap: {
        Transport: 'transports',
        Accommodation: 'accommodations',
        'Food and Beverage': 'foods',
        Venues: 'venues'
      }
    };
  },
  computed: {
    ...mapState({
      excursionRiskCategories: (state) => state.excursions.riskCategoriesOptions
    }),
    placeholder() {
      return `Add ${this.name} Type`;
    },
    objId() {
      return `selectControl${this.id}`;
    },
    categoryName() {
      return this.name;
    },
    selectedRiskClasses() {
      return this.$store.getters['common/selectedClassByCategoryName'](this.name);
    },
    riskCategories() {
      const categoryName = this.riskCategoryMap[this.name];
      const subRisks = get(this.excursionRiskCategories, categoryName, []);
      return subRisks.flatMap((subRisk) => {
        const subRiskOption = subRisk.options.map((option) => ({
          title: option,
          subRiskType: subRisk.name,
          value: option
        }));

        return [{ type: 'subheader', title: subRisk.name, disabled: true }, ...subRiskOption];
      });
    },
    getDisabledState() {
      return (item) => {
        if (!item?.raw) return false;
        const riskParent = item.raw.subRiskType;
        const riskOption = item.raw.value;
        if (!this.selectedRiskClasses || this.selectedRiskClasses.length === 0) {
          return false;
        }
        return this.selectedRiskClasses[0].types.some((riskClass) => {
          return riskClass.name === riskParent && find(riskClass.classes, { name: riskOption });
        });
      };
    }
  },
  methods: {
    changeRiskCategory() {
      this.$emit('changeRiskCategoryDone', this.name);
    },
    onMultiSelectChange(selectedData) {
      const riskCategory = {
        name: this.categoryName
      };
      const riskClass = {
        name: selectedData.value
      };

      this.$store.dispatch('common/changeSelectRiskClass', {
        riskClass,
        riskTypeName: selectedData.subRiskType,
        riskCategory
      });

      this.changeRiskCategory();
    }
  }
};
</script>
